<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="listdesign" label="设计绩效考核列表" v-if="authDesign"></TabPane>
            <TabPane name="listrecord" label="投放绩效考核列表" v-if="authRecord"></TabPane>
            <TabPane name="kpidesign" label="设计奖金基准值设置" v-if="authStand"></TabPane>
            <TabPane name="expendesign" label="素材消耗导入列表" v-if="authExpend"></TabPane>
            <TabPane name="kpirecord" label="投放绩效KPI设置" v-if="authKpi"></TabPane>
            <TabPane name="cprecord" label="CP分成设置" v-if="authCp"></TabPane>
            <TabPane name="iosrecharge" label="自然量分配" v-if="authIos"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <keep-alive :max="10">
          <router-view />
        </keep-alive>
      </div>
    </Content>
  </Layout>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'record',
  computed: {
    authDesign() {
      return isArray(this.access) && this.access.includes('M20825')
    },
    authRecord() {
      return isArray(this.access) && this.access.includes('M20823')
    },
    authStand() {
      return isArray(this.access) && this.access.includes('M20828')
    },
    authExpend() {
      return isArray(this.access) && this.access.includes('M20830')
    },
    authKpi() {
      return isArray(this.access) && this.access.includes('M20831')
    },
    authCp() {
      return isArray(this.access) && this.access.includes('M20832')
    },
    authIos() {
      return isArray(this.access) && this.access.includes('M20833')
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.replace({ name })
    },
    getCurrent() {
      const hasAllAccess = ['M20825', 'M20823', 'M20828', 'M20830', 'M20831', 'M20832', 'M20833'].every((ret) => this.access.includes(ret))
      this.currentRoute = this.$route.name
      if (this.$route.name === 'record') {
        if (isArray(this.access) && hasAllAccess) {
          // 有全部Tab权限
          this.changeRouter('listdesign')
        } else {
          // 有部分Tab权限
          this.currentRoute = this.$route.name
          if (this.authDesign) this.changeRouter('listdesign')
          else if (this.authRecord) this.changeRouter('listrecord')
          else if (this.authStand) this.changeRouter('kpidesign')
          else if (this.authExpend) this.changeRouter('expendesign')
          else if (this.authKpi) this.changeRouter('kpirecord')
          else if (this.authCp) this.changeRouter('cprecord')
          else if (this.authIos) this.changeRouter('iosrecharge')
          else this.changeRouter('noauth')
        }
      }
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      currentRoute: '',
      access: this.$store.state.accessAuth
    }
  },
  created() {
    this.getCurrent()
    const routeName = this.$route.name
    if (routeName === 'listrecord' && !this.authRecord) this.changeRouter('noauth')
    else if (routeName === 'listdesign' && !this.authDesign) this.changeRouter('noauth')
    else if (routeName === 'kpirecord' && !this.authKpi) this.changeRouter('noauth')
    else if (routeName === 'kpidesign' && !this.authStand) this.changeRouter('noauth')
    else if (routeName === 'cprecord' && !this.authCp) this.changeRouter('noauth')
    else if (routeName === 'expendesign' && !this.authExpend) this.changeRouter('noauth')
    else if (routeName === 'iosrecharge' && !this.authIos) this.changeRouter('noauth')
  }
}
</script>
